import React from "react"

import { ProjectInput } from "entities/projects/ui/project-input/ProjectInput"

import { useProductPositionFormCoreContext } from "../../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormLoadingContext } from "../../contexts/ProductPositionFormLoadingContext"
import { useProductPositionFormSelectionContext } from "../../contexts/ProductPositionFormSelectionContext"

export const ProductPositionProjectInput = React.memo(() => {
  const { isReadonly, isDisabled, formOptions } =
    useProductPositionFormCoreContext()
  const { isLoadingProjectOptions } = useProductPositionFormLoadingContext()
  const { projectOptions } = useProductPositionFormSelectionContext()

  if (formOptions?.hideProject) return null

  return (
    <ProjectInput
      items={projectOptions}
      loading={isLoadingProjectOptions}
      readonly={isReadonly}
      disabled={isDisabled}
      required
    />
  )
})
